import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Batch } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listBatches = createAsyncThunk<
  Batch[],
  void,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_BATCHES, async (_, { extra }) => {
  return await extra.batchesRepo.listBatches();
});
